var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.event)?_c('event-form',{attrs:{"action":"update","loading":_vm.loading,"updating":_vm.updating,"data":_vm.event,"error-messages":_vm.errorMessages,"handle-submit":_vm.handleFormSubmit,"handle-discard":_vm.handleDiscard}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }